import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="loading"
export default class extends Controller {
  static targets = ["button", "text", "loadingText"]

  connect() {
    // Listen for turbo:click event on buttons with loading behavior
    this.element.addEventListener("turbo:click", this.showLoading.bind(this))
    this.element.addEventListener("turbo:before-visit", this.showLoading.bind(this))
    this.element.addEventListener("turbo:visit", this.hideLoading.bind(this))
  }

  showLoading() {
    if (this.hasTextTarget && this.hasLoadingTextTarget) {
      this.textTarget.classList.add("hidden")
      this.loadingTextTarget.classList.remove("hidden")
    }
    
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.classList.add("opacity-75", "cursor-not-allowed")
    }
  }

  hideLoading() {
    if (this.hasTextTarget && this.hasLoadingTextTarget) {
      this.textTarget.classList.remove("hidden")
      this.loadingTextTarget.classList.add("hidden")
    }
    
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false
      this.buttonTarget.classList.remove("opacity-75", "cursor-not-allowed")
    }
  }

  // For form submissions
  submit() {
    // Prevent double submissions
    if (this.hasButtonTarget && this.buttonTarget.disabled) {
      return false
    }
    
    this.showLoading()
    // Allow the form to submit normally
    return true
  }
}